import { RoadmapBanner } from '@/components/roadmap/RoadmapBanner';
import { SoonCard } from '@/components/roadmap/SoonCard';
import { useI18n } from '@/i18n';
import { soonItems } from '@/lib/comingSoon';

export function RoadmapPage() {
  const { t } = useI18n();
  const items = soonItems();

  return (
    <section className="roadmap-page">
      <div className="site-pad-x">
        <header className="page-header reveal is-in">
          <p className="eyebrow">{t('roadmap.eyebrow')}</p>
          <h1 className="page-title display">{t('roadmap.title')}</h1>
          <p className="page-lead">{t('roadmap.lead')}</p>
        </header>
      </div>

      <RoadmapBanner />

      <div className="site-pad-x">
        <h2 className="section-title roadmap-soon__title">{t('roadmap.soonTitle')}</h2>
        <div className="live-family-grid reveal is-in reveal-delay-1">
          {items.map((item) => (
            <SoonCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
